import { Navigate, Outlet } from "react-router-dom";
import PageLoading from "../customComponents/PageLoading";
import { useUserContext } from "@/contexts/UserContextProvider";

const ProtectedRoutes = () => {
  const { user, loading } = useUserContext();

  return loading ? (
    <PageLoading />
  ) : user ? (
    <Outlet />
  ) : (
    <Navigate to="/login" replace />
  );
};

export default ProtectedRoutes;
